import React, { useState } from 'react'
import { useForm } from 'react-hook-form'
import { apiCaller } from "@utils";
import { toast } from 'react-toastify';
import { useLocation, useParams } from 'react-router-dom'
import FreeTextDetail from '@components/teachV2/FreeTextDetail/FreeTextDetail';

export default function AnalyzeFreeTextPage() {
  const location = useLocation();
  let { idFreeText } = useParams();
  const [loadingResult, setLoadingResult] = useState(false)
  const [dataAnalyze, setDataAnalyze] = useState()
  const [loadingShowForm, setLoadingShowForm] = useState(false)
  const [dataFileImported, setDataFileImported] = useState(null);

  const {
    register,
    handleSubmit,
    setValue,
    control,
    watch
  } = useForm()
  
  const handleUpload = (data) => {
    const formData = new FormData();
    formData.append('Action', 'Edit');
    formData.append('Type', 'free_text');
    formData.append('QuestionItemId', idFreeText);
    formData.append('QuestionText', data?.question);
    formData.append('Rubric', { instruction_text: data?.rubrics });
    formData.append('ModelAnswer', data?.answer);
    dataFileImported && formData.append('MediaFile', dataFileImported);
    setLoadingResult(true)
    apiCaller(`/api/feedback/question/items/`, 'POST', formData).then(res => {
      if (res.status === 200) {
        setLoadingResult(false)
        toast.success("Successfully updated free-text question!", {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        getLoadDataDetail(idFreeText)
        setDataFileImported(null)
      } else {
        toast.error("Create new free-text question failed!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        setLoadingResult(false)
      }
    });
  };

  const getLoadDataDetail = async (id) => {
    const params = {
      Action: "LoadItem",
      QuestionItemId: id,
    }
    apiCaller(`/api/feedback/question/items/`, 'POST', params).then((res) => {
      const data = res?.data;
      if (res?.status === 200) {
        setDataAnalyze(data)
        console.log(data);
        setValue("answer", data?.ModelAnswer)
        setValue("rubrics", data?.Rubric?.instruction_text)
        setValue("question", data?.Contents?.question)
        setLoadingShowForm(true)
      } else {
        console.log("error");
      }
    })
  }

  const onSubmit = (data) => {
    handleUpload(data);
  }

  return (
    <div className="wrapper -freeTextPage">
      <form id="form-free-text" className="form-platform" onSubmit={handleSubmit(onSubmit)}>
        <FreeTextDetail 
          register={register}
          setValue={setValue}
          handleSubmit={handleSubmit}
          control={control}
          watch={watch}
          loadingResult={loadingResult}
          setLoadingResult={setLoadingResult}
          type={location?.state?.type}
          permission={location?.state?.permission}
          isShowReview={location?.state?.isShowReview}
          isShowFeedback={location?.state?.isShowFeedback}
          dataAnalyze={dataAnalyze}
          getLoadDataDetail={getLoadDataDetail}
          setLoadingShowForm={setLoadingShowForm}
          loadingShowForm={loadingShowForm}
          setDataFileImported={setDataFileImported}
          dataFileImported={dataFileImported}
        />
      </form>
    </div>
  )
}